// extracted by css-extract-rspack-plugin
export default {"button-wrapper":"omNrZl","buttonWrapper":"omNrZl","folder-description":"_vzzFg","folderDescription":"_vzzFg"};